import MuiLink from '@mui/material/Link'
import {Link} from 'gatsby'
import * as React from 'react'

import type {SxProps} from '@mui/material'

interface Props {
  key?: string | number
  children?: React.ReactNode
  to?: string
  href?: string
  contrast?: boolean
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2'
  bold?: boolean
  sx?: SxProps
}

const NavLink = ({
  children,
  contrast = false,
  to = '#',
  href,
  variant = 'body2',
  bold = false,
  sx = {},
}: Props) => {
  return (
    <MuiLink
      to={to}
      href={href}
      underline="none"
      variant={variant}
      sx={{
        color: contrast ? 'primary.contrastText' : 'text.primary',
        fontWeight: bold ? 'Medium' : 'normal',
        '&:hover': {
          color: 'primary.main',
        },
        ...sx,
      }}
      component={Link}
    >
      {children}
    </MuiLink>
  )
}

export default NavLink
